// Generic helper class for returning generic error messages

export default {
  getRequestSalesorderEmailBody(customerInfo) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    let body = i18n.t('/QuoteActions/Email/SalesOrderEmailBody')

    body = this.fillMessageTemplateWithCustomerInfo(body, customerInfo)

    return body
  },
  getRequestQuoteEmailBody(customerInfo) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    let body = i18n.t('/QuoteActions/Email/OrderEmailBody') //

    body = this.fillMessageTemplateWithCustomerInfo(body, customerInfo)
    return body
  },
  fillMessageTemplateWithCustomerInfo(messageTemplate, customerInfo, salesManName) {
    messageTemplate = messageTemplate.replace(
      '[AANHEF]',
      this.getSalutation(customerInfo.CustomerGender)
    )

    if (customerInfo.CustomerMiddleName != null && customerInfo.CustomerMiddleName != '') {
      messageTemplate = messageTemplate.replace(
        '[NAAM]',
        customerInfo.CustomerMiddleName + ' ' + customerInfo.CustomerFamilyName
      )
    } else {
      messageTemplate = messageTemplate.replace('[NAAM]', customerInfo.CustomerFamilyName)
    }

    if (salesManName && salesManName != '') {
      messageTemplate = messageTemplate.replace('[SALESNAAM]', salesManName)
    }

    return messageTemplate
  },
  getSalutation(gender) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    const salutationFemale = i18n.t('/QuoteActions/Email/SalutationFemale')
    const salutationMale = i18n.t('/QuoteActions/Email/SalutationMale')
    const salutationUnknown = i18n.t('/QuoteActions/Email/SalutationUnknown')

    gender = gender?.toLowerCase()

    if (gender == 'male' || gender == 'm') return salutationMale
    else if (gender == 'female' || gender == 'f') return salutationFemale
    else return salutationUnknown
  },
}
